import { Link } from 'react-router-dom';

import { BUSINESS_DISPLAY, hasReportedEcommerceNumber } from '../../config/business';

const infoRows = [
  ['상호', BUSINESS_DISPLAY.companyName],
  ['대표자', BUSINESS_DISPLAY.ceoName],
  ['사업자등록번호', BUSINESS_DISPLAY.businessNumber],
  ['사업장 주소', BUSINESS_DISPLAY.address],
  ['연락처', BUSINESS_DISPLAY.phone],
  ['이메일', BUSINESS_DISPLAY.email],
] as const;

const policyLinks = [
  { label: '이용약관', to: '/terms' },
  { label: '개인정보처리방침', to: '/privacy' },
  { label: '환불정책', to: '/refund' },
  { label: '사업자정보', to: '/business-info' },
  { label: '문의', to: '/contact' },
] as const;

interface CheckoutComplianceNoticeProps {
  className?: string;
}

function CheckoutComplianceNotice({ className = '' }: CheckoutComplianceNoticeProps) {
  return (
    <section
      className={`rounded-[1.5rem] border border-[#7c5a2f]/60 bg-[rgba(19,17,16,0.9)] p-5 text-sm text-[#e7d5bb] shadow-[0_24px_80px_rgba(0,0,0,0.32)] ${className}`}
    >
      <h2 className="text-base font-semibold text-[#f4e9d4]">서비스 및 결제 안내</h2>
      <div className="mt-3 space-y-2 text-[13px] leading-6 text-[#ceb693]">
        <p>충전된 츄르는 결제 완료 후 즉시 보유량에 반영됩니다.</p>
        <p>보유 츄르를 사용해 리딩을 시작하면 디지털 콘텐츠가 즉시 제공됩니다.</p>
        <p>미사용 츄르와 중복 결제, 디지털 콘텐츠 환불 기준은 환불정책에서 확인할 수 있습니다.</p>
        <p>사업자 정보와 이용약관, 개인정보처리방침은 아래 링크에서 확인할 수 있습니다.</p>
      </div>

      <dl className="mt-5 grid gap-3 md:grid-cols-2">
        {infoRows.map(([label, value]) => (
          <div
            key={label}
            className="rounded-xl border border-[#5c4522]/70 bg-[rgba(255,255,255,0.03)] px-4 py-3"
          >
            <dt className="text-[11px] tracking-[0.24em] text-[#b28a47]">{label}</dt>
            <dd className="mt-1 text-sm text-[#f4e9d4]">{value}</dd>
          </div>
        ))}
        {hasReportedEcommerceNumber ? (
          <div className="rounded-xl border border-[#5c4522]/70 bg-[rgba(255,255,255,0.03)] px-4 py-3 md:col-span-2">
            <dt className="text-[11px] tracking-[0.24em] text-[#b28a47]">통신판매업 신고번호</dt>
            <dd className="mt-1 text-sm text-[#f4e9d4]">{BUSINESS_DISPLAY.ecommerceNumber}</dd>
          </div>
        ) : null}
      </dl>

      <div className="mt-5 flex flex-wrap gap-2">
        {policyLinks.map((link) => (
          <Link
            key={link.to}
            className="rounded-full border border-[#7c5a2f]/60 px-4 py-2 text-xs tracking-[0.16em] text-[#f1d7a0] transition hover:border-[#d4a63d] hover:text-[#fff1c8]"
            to={link.to}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </section>
  );
}

export default CheckoutComplianceNotice;
